
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Share } from 'lucide-react';
import { motion } from 'framer-motion';

const ReferralCard = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Card className="overflow-hidden border shadow-sm">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold flex items-center gap-2">
              <Share className="h-5 w-5 text-primary" />
              Share TeenVisor
            </h2>
          </div>
          
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Share TeenVisor with your friends and help them discover amazing opportunities for their future!
            </p>
            
            <div className="flex flex-col space-y-2">
              <Button 
                className="w-full" 
                onClick={() => {
                  const text = 'Check out TeenVisor - an amazing platform for teens to explore opportunities, connect with mentors, and plan their future!';
                  window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(text), '_blank');
                }}
              >
                Share on Twitter
              </Button>
              
              <Button 
                variant="outline" 
                onClick={() => {
                  const text = 'Hey! Check out TeenVisor - an amazing platform for teens to explore opportunities, connect with mentors, and plan their future! Visit teenvisor.com';
                  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
                }}
              >
                Share on WhatsApp
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ReferralCard;
